import { Waves, Bath, Home, PawPrint, SunSnow } from "lucide-react";
import { FEATURES } from "../../data/tilio";
import { Reveal } from "./Shared";

const ICONS = { Waves, Bath, Home, PawPrint, SunSnow };

export default function Features() {
    return (
        <section data-testid="features-section" className="border-b border-stone/70 bg-[#F5F8F4]">
            <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-12 px-6 py-16 md:grid-cols-3 lg:grid-cols-6 lg:px-10 lg:py-20">
                {FEATURES.map((f, i) => {
                    const Icon = f.icon ? ICONS[f.icon] : null;
                    return (
                        <Reveal key={f.title} delay={i * 0.08} className="px-2 text-center">
                            {f.iconImg ? (
                                <img src={f.iconImg} alt="Masaż i gongi – gabinet masażu i relaksacji Tilio" title="Masaż i gongi – Tilio" className="mx-auto h-9 w-9 md:h-10 md:w-10 object-contain" data-testid={`feature-icon-${i}`} />
                            ) : (
                                <Icon className="mx-auto h-9 w-9 md:h-10 md:w-10 text-pine" strokeWidth={1.25} data-testid={`feature-icon-${i}`} />
                            )}
                            <h3 className="mt-5 flex min-h-[2.75em] items-center justify-center whitespace-pre-line font-serif text-xl md:text-2xl leading-snug text-pine" data-testid={`feature-title-${i}`}>
                                {f.title}
                            </h3>
                            <p className="mx-auto mt-2 min-h-[4.8em] max-w-[240px] whitespace-pre-line text-[17px] md:text-lg leading-[1.6] text-sage">{f.desc}</p>
                        </Reveal>
                    );
                })}
            </div>
        </section>
    );
}
